module.exports = __webpack_public_path__ + "static/media/publicsonar_crowdcontrol_selected.acb8d5a3.svg";